// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pEdiuMlf8xRSH5wQ4k7a {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    116.81deg,
    rgba(3, 120, 209, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  )
}

.J1ZO5_Z_TEkGC18ZcBlQ {
  display: flex;
  height: 400px;
  width: 100%;
  max-width: 531px;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 2rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background: linear-gradient(
    110.41deg,
    rgba(255, 255, 255, 0.67) -1.18%,
    rgba(255, 255, 255, 0.62) 98.72%
  )
}

.J1ZO5_Z_TEkGC18ZcBlQ .ant-input-outlined {
  border-radius: 5px !important
}

.VPaGtAxHegKZmc6mCLI1 {
  display: flex;
  justify-content: center;
  padding: 1.5rem
}

.F0Wig2FFkZo6F70Smnds {
  height: 3rem;
  width: 289px
}

.vzWL6mM630lx9RloKjr0 {
  text-align: center;
  font-family: Noto Sans;
  font-size: 35px;
  font-weight: 700
}

.FmACE2uzPz9huhioENwm {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.iGd4cTBbR08kwcucW56P {
  display: flex;
  gap: 1rem
}
.Edw_bbKX7zmlhsFpTGsk {
  width: 40%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.V7ccjnQlzem6sDGDB8dL {
  margin-right: 0.25rem;
  height: 17px;
  width: 14px
}
.pjHhXj_A5MPDBx0Z4xv_ {
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.EwBLt_kpszlgMf3QS_TT {
  margin-right: 0.25rem;
  height: 14px;
  width: 14px
}
.mXE9dC6gye_3N_EzbE5j {
  margin-bottom: 0px !important
}

.jpX_x3M4lU21GHtezjYh {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.jpX_x3M4lU21GHtezjYh:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.y2GdoOExKzSY7fsAZBUY {
  margin-top: 1rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.module.css"],"names":[],"mappings":"AACE;EAAA,aAAoD;EAApD,iBAAoD;EAApD,mBAAoD;EAApD,uBAAoD;EACpD;;;;;AADoD;;AASpD;EAAA,aAAuG;EAAvG,aAAuG;EAAvG,WAAuG;EAAvG,gBAAuG;EAAvG,sBAAuG;EAAvG,uBAAuG;EAAvG,kBAAuG;EAAvG,kBAAuG;EAAvG,4DAAuG;EAAvG,aAAuG;EAAvG,+EAAuG;EAAvG,mGAAuG;EAAvG,uGAAuG;EACvG;;;;;AADuG;;AASvG;EAAA;AAAqB;;AAIrB;EAAA,aAA8B;EAA9B,uBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,YAAqB;EAArB;AAAqB;;AAIrB;EAAA,kBAAmD;EAAnD,sBAAmD;EAAnD,eAAmD;EAAnD;AAAmD;;AAInD;EAAA,qBAAiH;EAAjH,aAAiH;EAAjH,mBAAiH;EAAjH,uBAAiH;EAAjH,mBAAiH;EAAjH,sBAAiH;EAAjH,oBAAiH;EAAjH,qBAAiH;EAAjH,kBAAiH;EAAjH,sBAAiH;EAAjH,eAAiH;EAAjH,gBAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAGjH;EAAA,aAAiB;EAAjB;AAAiB;AAGjB;EAAA,UAA+D;EAA/D,sBAA+D;EAA/D,eAA+D;EAA/D,gBAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;AAG/D;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA,sBAAuD;EAAvD,eAAuD;EAAvD,gBAAuD;EAAvD,oBAAuD;EAAvD;AAAuD;AAGvD;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA;AAAY;;AAIZ;EAAA,YAA8G;EAA9G,WAA8G;EAA9G,kBAA8G;EAA9G,6BAA8G;EAA9G,qEAA8G;EAA9G,eAA8G;EAA9G,gBAA8G;EAA9G,oBAA8G;EAA9G;AAA8G;;AAA9G;EAAA,+BAA8G;EAA9G;AAA8G;;AAI9G;EAAA,gBAA2H;EAA3H,aAA2H;EAA3H,eAA2H;EAA3H,mBAA2H;EAA3H,uBAA2H;EAA3H,YAA2H;EAA3H,kBAA2H;EAA3H,sBAA2H;EAA3H,eAA2H;EAA3H,gBAA2H;EAA3H,oBAA2H;EAA3H;AAA2H","sourcesContent":[".gradientBg {\n  @apply flex items-center justify-center min-h-screen;\n  background: linear-gradient(\n    116.81deg,\n    rgba(3, 120, 209, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.formContainer {\n  @apply bg-white rounded-[5px] shadow-lg p-8 w-full max-w-[531px] h-[400px] flex flex-col justify-center;\n  background: linear-gradient(\n    110.41deg,\n    rgba(255, 255, 255, 0.67) -1.18%,\n    rgba(255, 255, 255, 0.62) 98.72%\n  );\n}\n\n.formContainer :global(.ant-input-outlined) {\n  @apply !rounded-[5px];\n}\n\n.logo {\n  @apply flex justify-center p-6;\n}\n\n.logoImage {\n  @apply w-[289px] h-12;\n}\n\n.loginHeading {\n  @apply text-[35px] font-bold font-inter text-center;\n}\n\n.loginSubTitle {\n  @apply font-inter text-gray-400 font-button text-body py-2 mb-6 flex items-center justify-center text-center px-6;\n}\n.gridForm {\n  @apply flex gap-4;\n}\n.tenantCode {\n  @apply w-[40%] text-gray-500 font-inter font-button text-button;\n}\n.tenantIcon {\n  @apply w-[14px] h-[17px] mr-1;\n}\n.userId {\n  @apply text-gray-500 font-inter font-button text-button;\n}\n.userIcon {\n  @apply w-[14px] h-[14px] mr-1;\n}\n.login {\n  @apply !mb-0;\n}\n\n.submitButton {\n  @apply !bg-secondary w-full h-[50px] text-button font-dashboardMain text-white rounded-[5px] hover:!text-white;\n}\n\n.footer {\n  @apply text-[12px] font-bold text-primary mt-4 font-inter flex items-center justify-center text-center gap-1 cursor-pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gradientBg": `pEdiuMlf8xRSH5wQ4k7a`,
	"formContainer": `J1ZO5_Z_TEkGC18ZcBlQ`,
	"logo": `VPaGtAxHegKZmc6mCLI1`,
	"logoImage": `F0Wig2FFkZo6F70Smnds`,
	"loginHeading": `vzWL6mM630lx9RloKjr0`,
	"loginSubTitle": `FmACE2uzPz9huhioENwm`,
	"gridForm": `iGd4cTBbR08kwcucW56P`,
	"tenantCode": `Edw_bbKX7zmlhsFpTGsk`,
	"tenantIcon": `V7ccjnQlzem6sDGDB8dL`,
	"userId": `pjHhXj_A5MPDBx0Z4xv_`,
	"userIcon": `EwBLt_kpszlgMf3QS_TT`,
	"login": `mXE9dC6gye_3N_EzbE5j`,
	"submitButton": `jpX_x3M4lU21GHtezjYh`,
	"footer": `y2GdoOExKzSY7fsAZBUY`
};
export default ___CSS_LOADER_EXPORT___;
